//Génerer l'attestion de travail employeur
export class Attestation{    
    public civilite: string  = "";
    public prenom: string = "";    
    public nom: string = "";
    public email: string = "";
    public dateNaissance: Date ;
    public lieuNaissance: string = "";
    public adresse: string = "";
    public profil: string = "";
    public dateDebutContrat: Date;    
    public salaireBrut: number = 0;
    public dateDuJour: Date;  
    
    constructor() { }
  } 


// WEBPACK FOOTER //
// ./src/app/entities/attestation.ts